import { api } from './api'

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
}

export interface UpdateProfileRequest {
  name?: string
  email?: string
  timezone?: string
  personalLink?: string // For Quick SMS [AgentLink] variable
  pseudo?: string // Nickname for [AgentName] variable in scripts
}

class ProfileService {
  private static readonly BASE_PATH = '/auth'

  /**
   * Change user password
   */
  static async changePassword(data: ChangePasswordRequest): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`${this.BASE_PATH}/change-password`, data)
    return response.data
  }

  /**
   * Get current user profile
   */
  static async getProfile(): Promise<any> {
    const response = await api.get(`${this.BASE_PATH}/profile`)
    return response.data
  }

  /**
   * Update current user profile
   */
  static async updateProfile(data: UpdateProfileRequest): Promise<any> {
    const response = await api.patch(`${this.BASE_PATH}/profile`, data)
    return response.data
  }
}

export default ProfileService
